/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Auth_DescriptionInputs */

const en_marketing_feature_auth_description = /** @type {(inputs: Marketing_Feature_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email and password on Better Auth, with verification and password reset flows.`)
};

const es_marketing_feature_auth_description = /** @type {(inputs: Marketing_Feature_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo y contraseña con Better Auth, con verificación y restablecimiento de contraseña.`)
};

const fr_marketing_feature_auth_description = /** @type {(inputs: Marketing_Feature_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail et mot de passe via Better Auth, avec vérification et réinitialisation du mot de passe.`)
};

/**
* | output |
* | --- |
* | "Email and password on Better Auth, with verification and password reset flows." |
*
* @param {Marketing_Feature_Auth_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_auth_description = /** @type {((inputs?: Marketing_Feature_Auth_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Auth_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_auth_description(inputs)
	if (locale === "es") return es_marketing_feature_auth_description(inputs)
	return fr_marketing_feature_auth_description(inputs)
});